import i18next from 'app/translations/i18n';

export const MODEL_TEXT = 'lang';

export const ModelErrors = [
  { errorKey: 'INVALID_LANG_VALUE', message: i18next.t('settings:error_lang_invalid_value') },
  { errorKey: 'LANG_NOT_AVAILABLE_FOR_UI', message: i18next.t('settings:error_lang_not_available_for_ui') },
];
